<div class="income-statement-dps">
  <klt-section title="Dividends per Share (DPS)" type="none">
    <div class="graph-box">
      <klt-graph
        [loading]="clientQuery.selectFinancialIsLoading$ | async"
        (filter)="runFilter($event)"
        [options]="options"
        [titles]="titles"
        [height]="height"
      ></klt-graph>
    </div>
  </klt-section>
</div>
